import { fromSnakeCase } from './string';

export const camelizeObjProps = (obj) => {
  let transformedObj = {};

  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      let isNotObject = typeof obj[prop] !== 'object';
      let isArray = obj[prop] instanceof Array;
      const camelizedPropName = fromSnakeCase(prop).toCamelCase();

      if (isNotObject) {
        transformedObj[camelizedPropName] = obj[prop];
      } else if (isArray) {
        let arr = [];

        obj[prop].map((item) => {
          arr.push(camelizeObjProps(item));
        });

        transformedObj[camelizedPropName] = arr;
      } else if (obj[prop] === null) {
        transformedObj[camelizedPropName] = null;
      } else {
        transformedObj[camelizedPropName] = camelizeObjProps(obj[prop]);
      }
    }
  }

  return transformedObj;
};

/**
 * Essentially a polyfill for `Object.values`
 * */
export const valuesOf = (obj) => {
  // if the native method exists, use it
  if (typeof Object.values === 'function') {
    return Object.values(obj);
  }

  // otherwise, fallback to the polyfill implementation
  return Object.keys(obj).map((key) => obj[key]);
};

/**
 * This is the JS equivalent of Ruby's dig method.
 *
 * If dig is called as dig(foo, ['a', 'b', 'c']), it is equivalent to calling
 * foo.a.b.c but will take care of all the undefined checks along the way
 * before proceeding just as Ruby's dig does.
 */
export const dig = (obj, props) => {
  if (!props || props.length === 0) {
    return;
  }
  if (props.length === 1) {
    return obj[props[0]];
  }
  return dig(obj[props[0]], props.slice(1));
};

export const isAPromise = (obj) => {
  return typeof obj !== 'undefined' && typeof obj.then === 'function';
};

export const filterObjectProperties = (obj, acceptablePropertiesArray) => {
  return Object.keys(obj)
    .filter((propName) => acceptablePropertiesArray.includes(propName))
    .reduce((newObj, key) => {
      newObj[key] = obj[key];
      return newObj;
    }, {});
};

export const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
